import { AddressModel } from "../../data/entities";
import { AddressRepo, AddressODataRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class AddressService extends BaseEntityService<AddressModel, AddressRepo, AddressODataRepo> {
  constructor(){
    super(new AddressRepo(), new AddressODataRepo());
  }
}

export default AddressService;
